<template>
    <div>
        <div class="page-container">
            <div class="page-wrapper">
                <div class="page-header-title">
                    <div class="page-header-title-label">添加阶段性测试</div>
                </div>
                <div class="page-info-wrapper">
                    <div class="page-info">
                        说明：当用户学习完指定课程时，可以解锁阶段测试，阶段测试可不添加或添加多个
                    </div>
                    <!-- <div class="page-fresh-btn" @click="handleRefresh">刷新</div> -->
                </div>
                <div class="page-content-wrapper">
                    <div v-for="(item, key) in tableData" :key="key" class="page-content-item-wrapper">
                        <div class="info-img-wrapper">
                            <img src="@/assets/img/test-info.png" alt="" class="info-img">
                        </div>
                        <div class="page-content-item-label-wrapper">
                            <div class="page-content-item-label">{{ item.metaExamName }}</div>
                        </div>
                        <div class="page-content-btn-wrapper">
                            <div class="page-content-btn" @click="handleEdit(item)">编辑</div>
                            <div class="page-content-btn content-btn-gap" @click="handleDelete(item)">删除</div>
                        </div>
                    </div>
                    <div class="page-content-item-add" @click="handleAddTest">
                        <img src="@/assets/img/test-add.png" alt="" class="add-img">
                    </div>
                </div>
            </div>
        </div>

        <div class="page-bottom-wrapper">
            <div class="page-bottom-label">
                提示：该步骤可跳过，后期可继续添加
            </div>
            <div class="page-btn-wrapper">
                <div class="page-btn deal-btn btn-gap" @click="handleLast">上一步</div>
                <div class="page-btn deal-btn btn-gap" @click="handleNext">下一步</div>
                <div class="page-btn deal-btn btn-gap" @click="handleDeal">完成</div>
                <div class="page-btn cancel-btn btn-gap" @click="handleBack">取消</div>
            </div>
        </div>

        <!--综合测评-弹窗-->
        <el-dialog title="" :show-close="true" width="1250px" top="57px" :visible.sync="measureInfoDialog"
            class="dialog-container">
            <div class="dialog-header">
                <div>{{ dialogTitle }}</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-content-item dialog-content-item1">
                    <div class="dialog-form-item">
                        <div class="dialog-form-label">
                            阶段测评标题
                            <div class="dialog-form-require">*</div>
                        </div>
                        <div class="dialog-form-content">
                            <el-input v-model="form.title" placeholder="请输入阶段测评名称，最多10字" maxlength="10" clearable
                                style="width:100%;"></el-input>
                        </div>
                    </div>
                    <div class="dialog-form-item">
                        <div class="dialog-form-label">
                            相关课程
                            <div v-if="skip == false" class="dialog-form-require">*</div>
                        </div>
                        <div class="dialog-form-content">
                            <div class="dialog-form-checkbox-container">
                                <div class="dialog-form-checkbox-wrapper">
                                    <div class="dialog-form-all-check" v-if="form.course && form.course.length !== 0">
                                        <el-checkbox v-model="selectedAllChecked" @change="handleTotalSelected"
                                            :disabled="isAfterStartTime && editFlag">全选</el-checkbox>
                                    </div>
                                    <el-checkbox-group v-model="courseCheckList" @change="courseCheckChange">
                                        <div v-for="(item, key) in form.course" :key="key" class="dialog-form-checkbox">
                                            <el-checkbox :label="item.courseId" :disabled="isAfterStartTime && editFlag">{{
                                                item.courseName }}</el-checkbox>
                                        </div>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-form-item">
                        <div class="dialog-form-label">
                            <div class="dialog-label-block">
                                阶段测试时长
                                <div class="dialog-form-require">*</div>
                            </div>
                            <div class="selected-header-count">
                                <el-input-number v-model="form.time" :min="1" label="" size="mini"></el-input-number>
                            </div>
                            <div class="dialog-count-unit">分钟</div>
                        </div>
                    </div>
                    <div class="dialog-form-item">
                        <div class="dialog-form-label">
                            <div class="dialog-label-block">
                                可作答次数
                                <div class="dialog-form-require">*</div>
                            </div>
                            <div class="selected-header-count">
                                <el-input-number v-model="form.num" :min="secondCountMin" label=""
                                    size="mini"></el-input-number>
                            </div>
                            <div class="dialog-count-unit">次</div>
                        </div>
                    </div>
                    <div class="dialog-form-brief">
                        <div>说明</div>
                        <div>
                            1.相关课程：用户只有完成相关课程的学习，才能进行该阶段测试；
                        </div>
                        <div>
                            2.阶段测试时长：阶段测试答题时长；
                        </div>
                        <div>
                            3.可作答次数：用户可以做阶段测试的次数，如果次数大于1，将取成绩最高的一次作为最终成绩。
                        </div>
                    </div>
                </div>
                <div class="dialog-form-line"></div>
                <div class="dialog-content-item dialog-content-item2">
                    <div class="add-measure-header-wrapper">
                        <div class="add-measure-task-mode">
                            <div :class="exerciseMode == 'radio' ? 'add-measure-mode-btn-active add-measure-radio-btn' : 'add-measure-mode-btn add-measure-radio-btn'"
                                @click="handleMeasureTab('radio', true, true)">
                                单选题
                            </div>
                            <div :class="exerciseMode == 'checkbox' ? 'add-measure-mode-btn-active add-measure-checkbox-btn' : 'add-measure-mode-btn add-measure-checkbox-btn'"
                                @click="handleMeasureTab('checkbox', true, true)">
                                多选题
                            </div>
                            <div :class="exerciseMode == 'justify' ? 'add-measure-mode-btn-active add-measure-justify-btn' : 'add-measure-mode-btn add-measure-justify-btn'"
                                @click="handleMeasureTab('justify', true, true)">
                                判断题
                            </div>
                        </div>
                        <div class="add-measure-header-operate">
                            <div class="add-measure-btn measure-templete-btn" @click="downloadTemplete">模板</div>
                            <div :class="`add-measure-btn measure-upload-btn ${uploadFlag ? 'not-upload' : ''}`"
                                @click="handleUpload">批量导入</div>
                            <el-upload ref="upload" :action="uploadURL" v-if="uploadShowFlag" :limit="1"
                                :on-change="uploadTemplete" :on-success="handleAvatarSuccess" :show-file-list="false"
                                :auto-upload="false" :file-list="uploadList"
                                style="position:absolute;left:-100%;visibility:hidden;">
                                <div id="uploadBtn" class="add-measure-btn measure-upload-btn">批量导入</div>
                            </el-upload>
                        </div>
                    </div>
                    <div class="add-measure-exercise-container">
                        <div class="add-measure-exercise-wrapper">
                            <div v-for="(item, index) in exerciseTable" :key="index"
                                @click="viewQuestionDetail(item, index)"
                                :class="`add-measure-exercis-item ${setmeasureNotAvtive(item)}`">
                                {{ index + 1 }}
                            </div>
                            <div style="clear:both;"></div>
                        </div>
                    </div>
                    <div class="dialog-form-item">
                        <div class="dialog-form-label">
                            题干
                            <div class="dialog-form-textarea">
                                <el-input type="textarea" :rows="3" placeholder="请输入题干" v-model="exercise.title">
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-form-item">
                        <div class="dialog-form-label">
                            选项

                            <div v-if="exerciseMode == 'radio'" class="dialog-form-textarea">
                                <el-radio-group v-model="answerRadio" style="width:100%;" @change="changeOptions">
                                    <div v-for="(item, key) in exercise.options" :key="key" class="dialog-form-checkbox">
                                        <div class="dialog-form-option-radio">
                                            <el-radio :label="item.label" name="radio">{{ item.title }}</el-radio>
                                        </div>
                                        <div class="dialog-form-option-input" style="width:100%;">
                                            <el-input placeholder="请输入选项" v-model="item.value" clearable
                                                @input="changeOptions">
                                                <template slot="prepend">
                                                    <div style="width:8px;">{{ item.label }}</div>
                                                </template>
                                            </el-input>
                                        </div>
                                    </div>
                                </el-radio-group>
                            </div>
                            <div v-if="exerciseMode == 'checkbox'" class="dialog-form-textarea">
                                <div v-for="(item, index) in exercise.options" :key="'checkbox-' + index"
                                    class="dialog-form-checkbox">
                                    <div class="dialog-form-option-checkbox dialog-form-option-radio">
                                        <el-checkbox :label="item.label" v-model="item.checked" @change="changeCheckbox()">
                                            {{ item.title }}
                                        </el-checkbox>
                                    </div>
                                    <div class="dialog-form-option-input">
                                        <el-input style="width: 400px;" placeholder="请输入选项" v-model="item.value" clearable
                                            @input="changeCheckbox">
                                            <template slot="prepend">
                                                <div style="width:8px;">{{ item.label }}</div>
                                            </template>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <div v-if="exerciseMode == 'justify'" class="dialog-form-textarea">
                                <el-radio-group v-model="answerRadio" style="width:100%;" @change="changeOptions">
                                    <div v-for="(item, key) in exercise.options" :key="key" class="dialog-form-checkbox">
                                        <div class="dialog-form-option-radio">
                                            <el-radio :label="item.label" name="radio">{{ item.title }}</el-radio>
                                        </div>
                                        <div class="dialog-form-option-input" style="width:100%;">
                                            <el-input placeholder="请输入选项" v-model="item.value" clearable
                                                @input="changeOptions">
                                                <template slot="prepend">
                                                    <div style="width:8px;">{{ item.label }}</div>
                                                </template>
                                            </el-input>
                                        </div>
                                    </div>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-form-item">
                        <div class="dialog-form-label">
                            解析
                            <div class="dialog-form-textarea">
                                <el-input type="textarea" :rows="3" placeholder="请输入解析" v-model="exercise.analysis">
                                </el-input>
                            </div>
                        </div>
                    </div>
                    <div class="add-measure-bottom-btn-wrapper">
                        <div class="add-measure-bottom-btn add-measure-delete-btn" @click="deleteTest">删除</div>
                        <div class="add-measure-bottom-btn add-measure-keep-add-btn" @click="addTest">继续添加</div>
                    </div>
                </div>
            </div>
            <div v-if="activeMode = 'add'" class="dialog-footer">
                <div class="dialog-footer-btn dialog-footer-cancel" @click="handleCancelAddMeasure">取消</div>
                <div class="dialog-footer-btn dialog-footer-deal" @click="submitAddTest">确定</div>
            </div>
            <div v-else class="dialog-footer">
                <div class="dialog-footer-btn dialog-footer-cancel" @click="handleCancelEditMeasure">取消</div>
                <div class="dialog-footer-btn dialog-footer-deal" @click="submitEditTest">确定</div>
            </div>
        </el-dialog>

        <!--取消提示-->
        <el-dialog title="" :show-close="false" width="524px" :visible.sync="cancelDealDialog" class="dialog-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    阶段测评内容未保存，确认继续此操作吗？
                </div>
            </div>
            <div class="dialog-btn-wrapper">
                <div class="add-measure-bottom-btn add-measure-delete-btn" @click="cancelDealTips">取消</div>
                <div class="add-measure-bottom-btn add-measure-keep-add-btn" @click="handleCancelDeal">确定</div>
            </div>
        </el-dialog>

        <!--删除计划-->
        <el-dialog title="" :show-close="false" width="524px" :visible.sync="deletePlanDialog" class="dialog-container">
            <div class="dialog-header">
                <div>温馨提示</div>
            </div>
            <div class="dialog-content">
                <div class="dialog-info">
                    删除此阶段测试，阶段测试的内容也将被删除，是否确认此操作？
                </div>
            </div>
            <div class="dialog-btn-wrapper">
                <div class="add-measure-bottom-btn add-measure-delete-btn" @click="cancelDeletePartPlan">取消</div>
                <div class="add-measure-bottom-btn add-measure-keep-add-btn" @click="deletePartPlan">确定</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios';
const Qs = require('qs');
import config from '@/config';
const baseUrl = config.baseUrl;
let addId = 0;
import {
    partTestList,
    partTestListTwo,
    hasSelectedCourse,
    planTemplete,
    createPlanList,
    importPlanList,
    partTestQuestionList,
    partTestDetail,
    partTestQuestionDetail,
    removePartPlan,
    partTestQuestionListByEdit,
    saveStageExam,
    deleteTestQuestion
} from '@/api/index.js';

export default {
    name: '',
    components: {

    },
    data() {
        return {
            skip: '',
            dept: '',
            token: '',
            activeMode: 'add',
            activeModeType: 'add',
            tableData: [],
            measureInfoDialog: false,
            dialogTitle: '添加阶段测评',
            form: {
                title: '',
                course: [],
                time: 30,
                num: 1
            },
            uploadURL: '',
            uploadList: [],
            selectedAllChecked: false,
            courseCheckList: [],
            exercise: {
                title: '',
                analysis: '',
                options: [
                    {
                        label: 'A',
                        title: '正确',
                        value: '',
                        checked: false
                    },
                    {
                        label: 'B',
                        title: '正确',
                        value: '',
                        checked: false
                    },
                    {
                        label: 'C',
                        title: '正确',
                        value: '',
                        checked: false
                    },
                    {
                        label: 'D',
                        title: '正确',
                        value: '',
                        checked: false
                    }
                ]
            },
            exerciseMode: 'radio',
            exerciseTable: [], // 答案数据
            answerRadio: '',
            questionOptions: [],
            questionAnswer: '',
            hasAddTest: false,
            activExamId: '',
            cancelDealDialog: false,
            activeEdit: {},
            deletePlanDialog: false,
            activeDelete: {},
            reqTwoMethodsFlag: true, // 判断是否请求接口后缀带2的接口
            metaQuestionId: null, // 当前问题id
            metaQuestionType: 1, // 当前问题类型
            metaQuestionIndex: null, // 当前问题下标
            addQuestionList: [], // 新增的列表
            updateQuestionList: [],// 修改的列表
            deleteQuestionIdList: [], // 删除列表
            radioQuestionList: [], // 单选的数据列表
            checkboxQuestionList: [], // 多选的数据列表
            justifyQuestionList: [], // 判断的数据列表
            uploadFlag: false, // 单选是不是导入过的标识
            initFlage: false, // 初始化标识
            uploadActivExamId: false, // 上传后的返回id
            activeaddId: null, // 当前新增的id
            editRadioFlag: false, // 单选是否点击编辑进入请求完数据操作不在请求
            editCheckboxFlag: false, // 单选是否点击编辑进入请求完数据操作不在请求
            editJustifyFlag: false, // 单选是否点击编辑进入请求完数据操作不在请求
            radioQuestionNumber: 1, // 单选问题序号
            checkboxQuestionNumber: 0, // 多选问题序号
            justifyQuestionNumber: 0, // 判断题问题序号
            updateQuestionNumberList: [], // 更新的题目序号列表
            uploadShowFlag: false,
            isAfterStartTime: this.$route.query.isAfterStartTime ? JSON.parse(this.$route.query.isAfterStartTime) : false, // 是否为开始时间后进来编辑
            editFlag: false, // 编辑标识
            secondCountMin: 1,
        }
    },
    watch: {
        exercise: {
            handler(val) {
                if (val) {
                    this.setaddUpdateQuestionList()
                }
            },
            deep: true
        },
    },
    mounted() {

        this.skip = JSON.parse(localStorage.getItem('skip'))
        scrollTo(0, 0);
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        var planInfo = JSON.parse(window.localStorage.getItem('plan'));
        this.reqTwoMethodsFlag = planInfo.mode === 'edit' ? false : true
        this.editFlag = planInfo.mode === 'edit' ? true : false
        this.getTableData();
        this.uploadURL = baseUrl + '/api/saas/mplan/planStageExamTemplate';
    },
    methods: {
        // 设置需要更新得数据
        setaddUpdateQuestionList() {
            if (this.metaQuestionId && this.initFlage && !this.activeaddId) { // 编辑的
                this.$nextTick(() => {
                    var params = this.justifyTest();
                    params['type'] = 2;
                    params['metaQuestionId'] = this.metaQuestionId;
                    let updateItemIndex = this.updateQuestionList.findIndex((item) => item.metaQuestionId === this.metaQuestionId)
                    if (updateItemIndex > -1) {
                        this.updateQuestionList[updateItemIndex] = { ...params, ...{ editQuestionFlag: true } }
                    } else {
                        this.updateQuestionList.push({ ...params, ...{ editQuestionFlag: true } })
                    }
                    switch (this.exerciseMode) {
                        case 'radio':
                            let radioItemIndex = this.radioQuestionList.findIndex((item) => item.metaQuestionId === this.metaQuestionId)
                            if (radioItemIndex > -1) {
                                this.radioQuestionList[radioItemIndex] = { ...params, ...{ editQuestionFlag: true } }
                                this.setExerciseTable('radio');
                            }
                            break;
                        case 'checkbox':
                            let checkboxItemIndex = this.checkboxQuestionList.findIndex((item) => item.metaQuestionId === this.metaQuestionId)
                            if (checkboxItemIndex > -1) {
                                this.checkboxQuestionList[checkboxItemIndex] = { ...params, ...{ editQuestionFlag: true } }
                                this.setExerciseTable('checkbox');
                            }
                            break;
                        case 'justify':
                            let justifyItemIndex = this.justifyQuestionList.findIndex((item) => item.metaQuestionId === this.metaQuestionId)
                            if (justifyItemIndex > -1) {
                                this.justifyQuestionList[justifyItemIndex] = { ...params, ...{ editQuestionFlag: true } }
                                this.setExerciseTable('justify');
                            }
                            break;

                        default:
                            break;
                    }
                })
            } else if (this.initFlage && this.activeaddId) { // 新增的
                this.$nextTick(() => {
                    var params = this.justifyTest();
                    params['type'] = 2;
                    params['metaQuestionId'] = this.metaQuestionId;
                    let addItemIndex = this.addQuestionList.findIndex((item) => item.addId === this.activeaddId)
                    if (addItemIndex > -1) {
                        this.addQuestionList[addItemIndex] = { ...params, ...{ addId: this.addQuestionList[addItemIndex].addId, metaQuestionNumber: this.addQuestionList[addItemIndex].metaQuestionNumber } }
                    }
                    switch (this.exerciseMode) {
                        case 'radio':
                            let radioItemIndex = this.radioQuestionList.findIndex((item) => item.addId === this.activeaddId)
                            if (radioItemIndex > -1) {
                                this.radioQuestionList[radioItemIndex] = { ...params, ...{ addId: this.radioQuestionList[radioItemIndex].addId, metaQuestionNumber: this.radioQuestionList[radioItemIndex].metaQuestionNumber } }
                                this.setExerciseTable('radio');
                            }
                            break;
                        case 'checkbox':
                            let checkboxItemIndex = this.checkboxQuestionList.findIndex((item) => item.addId === this.activeaddId)
                            if (checkboxItemIndex > -1) {
                                this.checkboxQuestionList[checkboxItemIndex] = { ...params, ...{ addId: this.checkboxQuestionList[checkboxItemIndex].addId, metaQuestionNumber: this.checkboxQuestionList[checkboxItemIndex].metaQuestionNumber } }
                                this.setExerciseTable('checkbox');
                            }
                            break;
                        case 'justify':
                            let justifyItemIndex = this.justifyQuestionList.findIndex((item) => item.addId === this.activeaddId)
                            if (justifyItemIndex > -1) {
                                this.justifyQuestionList[justifyItemIndex] = { ...params, ...{ addId: this.justifyQuestionList[justifyItemIndex].addId, metaQuestionNumber: this.justifyQuestionList[justifyItemIndex].metaQuestionNumber } }
                                this.setExerciseTable('justify');
                            }
                            break;

                        default:
                            break;
                    }
                })
            }
        },
        getTableData() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            let reqMethods = partTestListTwo
            if (!this.reqTwoMethodsFlag) {
                reqMethods = partTestList
            }
            reqMethods(planInfo.id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleRefresh() {
            this.getTableData();
        },
        handleLast() {
            this.$emit('step', 'select-class');
        },
        handleNext() {
            var _this = this;
            this.savePartPlan(function () {
                _this.$emit('step', 'add-measure');
            });
        },
        savePartPlan(callback) {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            saveStageExam(planInfo.id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    callback();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleDeal() {
            var _this = this;
            this.savePartPlan(function () {
                _this.handleBack()
                _this.getTableData();
                _this.$message({
                    message: '添加成功',
                    type: 'success'
                });
            });
        },
        handleBack() {
            this.$router.go(-1);
          //  this.$router.push(`/studyPlan/manage-plan`);
        },
        handleAddTest() {
            if (this.isAfterStartTime && this.editFlag) {
                this.$message.error('考试已开始，不可添加新试卷');
                return
            }
            this.activeMode = 'add';
            this.activeModeType = 'add';
            this.dialogTitle = '添加阶段测评';
            var planData = JSON.parse(window.localStorage.getItem('plan'));
            planData.addTest = {
                isFinish: false,
                content: {},
                question: []
            }
            window.localStorage.setItem('plan', JSON.stringify(planData));
            this.exerciseMode = 'radio';
            this.resetFormData();
            this.exerciseTable = [];
            this.metaQuestionId = null; // 当前问题id
            this.metaQuestionType = 1; // 当前问题类型
            this.metaQuestionIndex = null; // 当前问题下标
            this.addQuestionList = []; // 新增的列表
            this.updateQuestionList = [];// 修改的列表
            this.deleteQuestionIdList = []; // 删除列表
            this.radioQuestionList = []; // 单选的数据列表
            this.checkboxQuestionList = []; // 多选的数据列表
            this.justifyQuestionList = []; // 判断的数据列表
            this.uploadFlag = false; // 是不是导入的标识
            this.initFlage = false; // 是不是导入的标识
            this.activeaddId = null // 当前新增的id
            this.editRadioFlag = false; // 单选是否点击编辑进入请求完数据操作不在请求
            this.editCheckboxFlag = false; // 单选是否点击编辑进入请求完数据操作不在请求
            this.editJustifyFlag = false; // 单选是否点击编辑进入请求完数据操作不在请求
            this.radioQuestionNumber = 1; // 单选问题序号
            this.checkboxQuestionNumber = 0; // 多选问题序号
            this.justifyQuestionNumber = 0; // 判断题问题序号
            this.updateQuestionNumberList = []; // 更新的题目序号列表
            this.selectedAllChecked = false; // 课程全选标识
            this.secondCountMin = 1;
            this.getHasSelectedCourse();
            // 如果是新增
            // if(planData.mode === 'add'){
            addId++
            let addIdVal = addId
            this.$set(this.exerciseTable, 0, {
                metaQuestionId: null,
                addId: addIdVal,
                metaQuestionNumber: 1
            })
            this.$set(this.radioQuestionList, 0, {
                metaQuestionId: null,
                addId: addIdVal,
                metaQuestionNumber: 1
            })
            this.$set(this.addQuestionList, 0, {
                metaQuestionId: null,
                addId: addIdVal,
                metaQuestionNumber: 1
            })
            // }
            this.viewQuestionDetail(this.exerciseTable[0], 0)
            this.measureInfoDialog = true;
        },
        justifyTest() {
            var form = this.form;
            var metaExamName = form.title;
            // if(metaExamName==''){
            //     this.$message.error('请输入阶段测评标题');
            //     return false;
            // }
            var courseCheckList = this.courseCheckList;
            // if(courseCheckList.length==0){
            //     this.$message.error('请选择相关课程');
            //     return false;
            // }
            var metaExamTime = form.time;
            if (metaExamTime == '') {
                this.$message.error('请输入阶段测试时长');
                return false;
            }
            if (isNaN(metaExamTime)) {
                this.$message.error('阶段测试时长应输入数字');
                return false;
            }
            var metaMaxExamCount = form.num;
            if (metaMaxExamCount == '') {
                this.$message.error('请输入可作答次数');
                return false;
            }
            if (isNaN(metaMaxExamCount)) {
                this.$message.error('可作答次数应输入数字');
                return false;
            }
            var exerciseType = 1;
            switch (this.exerciseMode) {
                case 'radio':
                    exerciseType = 1;
                    break;
                case 'checkbox':
                    exerciseType = 2;
                    break;
                case 'justify':
                    exerciseType = 3;
                    break;
            }
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            var params = {
                // metaExamName:metaExamName,
                // courseIdList:JSON.stringify(courseCheckList),
                //file:'',
                // metaExamTime:metaExamTime,
                // metaMaxExamCount:metaMaxExamCount,
                metaQuestionOptions: JSON.stringify(this.questionOptions),
                metaQuestionType: exerciseType,
                // planId:planInfo.id,
                // userId:0
            };
            if (this.activExamId != '') {
                params['metaExamId'] = this.activExamId;
            }
            var exercise = this.exercise;
            if (exercise.title != '') {
                params['metaQuestionTitle'] = exercise.title;
            }
            var questionAnswer = this.questionAnswer;
            if (questionAnswer != '') {
                params['metaQuestionAnswer'] = questionAnswer;
            }
            if (this.exercise.analysis != '' && this.exercise.analysis != null) {
                params["metaQuestionAnalysis"] = this.exercise.analysis;
            }
            return params;
        },
        // 继续添加
        addTest() {
            var params = this.justifyTest();
            let isAdd = true
            switch (params.metaQuestionType) {
                case 1:
                    this.radioQuestionList && this.radioQuestionList.forEach((item) => { // 单选的数据列表
                        if (!item.metaQuestionTitle || !item.metaQuestionOptions) {
                            isAdd = false
                        }
                        if (item.metaQuestionId) {
                            isAdd = true
                        }
                    })
                    break;
                case 2:
                    this.checkboxQuestionList && this.checkboxQuestionList.forEach((item) => { // 多选的数据列表
                        if (!item.metaQuestionTitle || !item.metaQuestionOptions) {
                            isAdd = false
                        }
                        if (item.metaQuestionId) {
                            isAdd = true
                        }
                    })
                    break;
                case 3:
                    this.justifyQuestionList && this.justifyQuestionList.forEach((item) => { // 判断的数据列表
                        if (!item.metaQuestionTitle || !item.metaQuestionOptions) {
                            isAdd = false
                        }
                        if (item.metaQuestionId) {
                            isAdd = true
                        }
                    })
                    break;

                default:
                    break;
            }
            if (!isAdd) {
                this.$message.error('存在未填写完整的题目，请完善！');
                return
            }
            params['type'] = 2;
            // if(params.metaQuestionTitle==''){
            //     this.$message.error('请输入题干');
            //     return false;
            // }
            var planData = JSON.parse(window.localStorage.getItem('plan'));
            // 如果是新的问题
            // if(!this.metaQuestionId){
            addId++
            let addIdVal = addId
            // 判断序号
            let metaQuestionNumber = 1;
            if (this.exerciseMode === 'radio') {
                this.radioQuestionNumber++
                metaQuestionNumber = this.radioQuestionNumber; // 单选
            } else if (this.exerciseMode === 'checkbox') { // 多选
                this.checkboxQuestionNumber++
                metaQuestionNumber = this.checkboxQuestionNumber
            } else if (this.exerciseMode === 'justify') { // 判断题
                this.justifyQuestionNumber++
                metaQuestionNumber = this.justifyQuestionNumber
            }
            this.addQuestionList.push({ ...params, ...{ addId: addIdVal, metaQuestionNumber } })
            switch (params.metaQuestionType) {
                case 1:
                    this.radioQuestionList.push({
                        metaQuestionId: null,
                        addId: addIdVal,
                        metaQuestionNumber
                    })
                    this.setExerciseTable('radio');
                    // this.radioQuestionList.push({metaQuestionId: null})
                    break;
                case 2:
                    this.checkboxQuestionList.push({
                        metaQuestionId: null,
                        addId: addIdVal,
                        metaQuestionNumber
                    })
                    this.setExerciseTable('checkbox');
                    // this.checkboxQuestionList.push({metaQuestionId: null})
                    break;
                case 3:
                    this.justifyQuestionList.push({
                        metaQuestionId: null,
                        addId: addIdVal,
                        metaQuestionNumber
                    })
                    this.setExerciseTable('justify');
                    // this.justifyQuestionList.push({metaQuestionId: null})
                    break;

                default:
                    break;
                // }
                // addId ++
                // addIdVal = addId
                // this.$set(this.exerciseTable,this.exerciseTable.length,{
                //     metaQuestionId: null,
                //     addId: addIdVal
                // })
                // this.addQuestionList.push({metaQuestionId: null})
            }
            planData.addTest.isFinish = true;
            planData.addTest.content = params;
            window.localStorage.setItem('plan', JSON.stringify(planData));
            this.hasAddTest = true;
            // this.exercise.title='';
            // this.exercise.analysis='';
            // this.answerRadio='';
            // this.questionOptions=[];
            // this.questionAnswer='';
            // var exerciseMode=this.exerciseMode;
            // this.handleMeasureTab(exerciseMode);
            // createPlanList(Qs.stringify(params),{},{
            //     Authorization:this.token,
            //     DeptId:this.dept
            // }).then(res => {
            //     if(res.code==200){
            //         if(!this.hasAddTest){
            //             params["metaExamId"]=res.data;
            //             this.activExamId=res.data;
            //         }
            //         var planData=JSON.parse(window.localStorage.getItem('plan'));
            //         planData.addTest.isFinish=true;
            //         planData.addTest.content=params;
            //         window.localStorage.setItem('plan',JSON.stringify(planData));
            //         this.hasAddTest=true;
            //         this.exercise.title='';
            //         this.exercise.analysis='';
            //         this.answerRadio='';
            //         this.questionOptions=[];
            //         this.questionAnswer='';
            //         var exerciseMode=this.exerciseMode;
            //         this.handleMeasureTab(exerciseMode);
            //     }else{
            //         this.$message.error(res.msg);
            //     }
            //     return;
            // }).catch(err => {
            //    // console.log(err);
            // });
        },
        // 删除题目
        deleteTest() {
            if (this.metaQuestionIndex === undefined || this.metaQuestionIndex === null) {
                this.$message({
                    type: 'error',
                    message: '请选择要删除的题目'
                });
            } else {
                this.$confirm('此操作将删除该题目, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 如果存在题目id
                    if (this.metaQuestionId) {
                        this.deleteQuestionIdList.push(this.metaQuestionId)
                        this.metaQuestionId = null;
                    }
                    switch (this.metaQuestionType) {
                        case 1:
                            this.$delete(this.radioQuestionList, this.metaQuestionIndex)
                            this.setExerciseTable('radio')
                            break;
                        case 2:
                            this.$delete(this.checkboxQuestionList, this.metaQuestionIndex)
                            this.setExerciseTable('checkbox')
                            break;
                        case 3:
                            this.$delete(this.justifyQuestionList, this.metaQuestionIndex)
                            this.setExerciseTable('justify')
                            break;
                        default:
                            break;
                    }
                    this.addQuestionList = this.addQuestionList.filter((item) => item.addId !== this.activeaddId)
                    this.exercise.title = '';
                    this.exercise.analysis = '';
                    this.answerRadio = '';
                    this.questionOptions = [];
                    this.questionAnswer = '';
                    var exerciseMode = this.exerciseMode;
                    this.handleMeasureTab(exerciseMode, false);
                    // 删除后返回上一个题目
                    this.$nextTick(() => {
                        let retruenIndex = this.metaQuestionIndex - 1
                        if (this.exerciseTable && this.exerciseTable.length !== 0 && retruenIndex !== -1) {
                            this.viewQuestionDetail(this.exerciseTable[retruenIndex])
                        }
                    })
                    // deleteTestQuestion(this.metaQuestionId,{},{
                    //     Authorization:this.token,
                    //     DeptId:this.dept
                    // }).then(res => {
                    //     this.getPlanQuestionList()
                    //     if(res.code==200){
                    //         this.$message({
                    //             type: 'success',
                    //             message: '删除成功'
                    //         });
                    //     }
                    //     return;
                    // }).catch(err => {
                    //    // console.log(err);
                    // });
                }).catch(() => {
                });
            }
        },
        async getPlanQuestionList() {
            var questionMode = this.exerciseMode;
            var questionType;
            switch (questionMode) {
                case 'radio': questionType = 1; break;
                case 'checkbox': questionType = 2; break;
                case 'justify': questionType = 3; break;
            }
            var examId = this.activExamId;
            await partTestQuestionList(examId, questionType, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    // 如果存在删除数据
                    if (this.deleteQuestionIdList && this.deleteQuestionIdList.length !== 0) {
                        this.exerciseTable = res.data && res.data.filter((item) => {
                            return !this.deleteQuestionIdList.includes(item.metaQuestionId)
                        });
                    } else {
                        this.exerciseTable = res.data;
                    }
                    switch (questionMode) {
                        case 'radio':
                            this.radioQuestionList = JSON.parse(JSON.stringify(res.data));
                            this.radioQuestionNumber = this.radioQuestionList.length; // 单选问题序号
                            this.editRadioFlag = true
                            break;
                        case 'checkbox':
                            this.checkboxQuestionList = JSON.parse(JSON.stringify(res.data));
                            this.checkboxQuestionNumber = this.checkboxQuestionList.length; // 多选问题序号
                            this.editCheckboxFlag = true
                            break;
                        case 'justify':
                            this.justifyQuestionList = JSON.parse(JSON.stringify(res.data));
                            this.justifyQuestionNumber = this.justifyQuestionList.length; // 判断题问题序号
                            this.editJustifyFlag = true
                            break;
                    }
                    if (this.exerciseTable && this.exerciseTable.length !== 0 && this.activeModeType === 'edit') {
                        this.$nextTick(() => {
                            this.viewQuestionDetail(this.exerciseTable[0])
                        })
                    } else if (!this.exerciseTable || this.exerciseTable.length === 0) {
                        this.metaQuestionId = null; // 当前问题id
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        questionTableInit() {
            var questionMode = this.exerciseMode;
            var questionType;
            switch (questionMode) {
                case 'radio': questionType = 1; break;
                case 'checkbox': questionType = 2; break;
                case 'justify': questionType = 3; break;
            }
            var examId = this.activExamId;
            partTestQuestionListByEdit(examId, questionType, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    // 如果存在删除数据
                    if (this.deleteQuestionIdList && this.deleteQuestionIdList.length !== 0) {
                        this.exerciseTable = res.data && res.data.filter((item) => {
                            return !this.deleteQuestionIdList.includes(item.metaQuestionId)
                        });
                    } else {
                        this.exerciseTable = res.data;
                    }
                    switch (questionMode) {
                        case 'radio':
                            this.radioQuestionList = JSON.parse(JSON.stringify(res.data));
                            this.radioQuestionNumber = this.radioQuestionList.length; // 单选问题序号
                            this.editRadioFlag = true
                            break;
                        case 'checkbox':
                            this.checkboxQuestionList = JSON.parse(JSON.stringify(res.data));
                            this.checkboxQuestionNumber = this.checkboxQuestionList.length; // 多选问题序号
                            this.editCheckboxFlag = true
                            break;
                        case 'justify':
                            this.justifyQuestionList = JSON.parse(JSON.stringify(res.data));
                            this.justifyQuestionNumber = this.justifyQuestionList.length; // 判断题问题序号
                            this.editJustifyFlag = true
                            break;
                    }
                    if (this.exerciseTable && this.exerciseTable.length !== 0 && this.activeModeType === 'edit') {
                        this.$nextTick(() => {
                            this.viewQuestionDetail(this.exerciseTable[0])
                        })
                    } else if (!this.exerciseTable || this.exerciseTable.length === 0) {
                        this.metaQuestionId = null; // 当前问题id
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        resetFormData() {
            this.form = {
                title: '',
                course: [],
                time: 30,
                num: 1
            };
            this.hasAddTest = true;
            this.activExamId = '';
            this.courseCheckList = [];
            this.exercise.title = '';
            this.exercise.analysis = '';
            this.exerciseTable = [];
            this.answerRadio = '';
            this.questionOptions = [];
            this.questionAnswer = '';
            var exerciseMode = this.exerciseMode;
            this.handleMeasureTab(exerciseMode);
        },
        async submitAddTest() {
            if (this.hasAddTest) {
                if (this.radioQuestionList.length === 0 && this.checkboxQuestionList.length === 0 && this.justifyQuestionList.length === 0) {
                    this.$message.error('请至少添加一个题目');
                    return
                }
                var metaExamName = this.form.title;
                if (metaExamName == '') {
                    this.$message.error('请输入阶段测评标题');
                    return;
                }
                var courseCheckList = this.courseCheckList;

                if (this.skip == false) {
                    if (courseCheckList.length == 0) {
                        this.$message.error('请选择相关课程');
                        return;
                    }
                }

                let nextFlag = true
                if (this.editFlag && this.isAfterStartTime) {
                    await this.$confirm('修改试题可能会影响成绩的准确性！', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        nextFlag = true
                    }).catch(() => {
                        nextFlag = false
                    });
                }
                if (!nextFlag) {
                    return
                }
                // let isSave = true
                // this.radioQuestionList && this.radioQuestionList.forEach((item)=>{ // 单选的数据列表
                //     if(!item.metaQuestionTitle || !item.metaQuestionOptions && !item.metaQuestionId){
                //         isSave = false
                //     }
                // })
                // this.checkboxQuestionList && this.checkboxQuestionList.forEach((item)=>{ // 多选的数据列表
                //     if(!item.metaQuestionTitle || !item.metaQuestionOptions && !item.metaQuestionId){
                //         isSave = false
                //     }
                // })
                // this.justifyQuestionList && this.justifyQuestionList.forEach((item)=>{ // 判断的数据列表
                //     if(!item.metaQuestionTitle || !item.metaQuestionOptions && !item.metaQuestionId){
                //         isSave = false
                //     }
                // })
                // if(!isSave){
                //     this.$message.error('存在未填写完整的题目，请完善！');
                //     return
                // }
                // var params=this.justifyTest();
                // params['type']=3;
                var planInfo = JSON.parse(window.localStorage.getItem('plan'));
                var params = {}
                // params['userId']=0;
                // params['type']=3;
                params['planId'] = planInfo.id;
                if (this.activExamId) {
                    params['metaExamId'] = this.activExamId;
                }
                let addQuestionList = this.addQuestionList
                if (this.addQuestionList.length !== 0) {
                    addQuestionList = this.addQuestionList.filter((item) => item.metaQuestionTitle)
                }
                params['metaExamName'] = this.form.title;
                params['metaExamTime'] = this.form.time;
                params['metaMaxExamCount'] = this.form.num;
                params['courseIdList'] = this.courseCheckList;
                params['deleteQuestionIdList'] = this.deleteQuestionIdList;
                params['addQuestionList'] = addQuestionList;
                params['updateQuestionList'] = this.updateQuestionList;
                params['updateQuestionNumberList'] = this.updateQuestionNumberList;
                createPlanList(params, {
                    Authorization: this.token,
                    DeptId: this.dept
                }).then(res => {
                    if (res.code == 200) {
                        this.measureInfoDialog = false;
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        // 如果是新增
                        if (this.activeModeType === 'add') {
                            this.reqTwoMethodsFlag = true
                        }
                        this.getTableData();
                    } else {
                        this.$message.error(res.msg);
                    }
                    return;
                }).catch(err => {
                    // console.log(err);
                });
            } else {
                this.$message.error('请至少添加一个阶段测评');
            }
        },
        handleEdit(row) {
            this.activeMode = 'edit';
            this.activeModeType = 'edit';
            this.dialogTitle = '编辑阶段测评';
            this.activeEdit = row;
            this.activExamId = row.metaExamId;
            this.hasAddTest = true;
            this.exerciseMode = 'radio';
            this.editRadioFlag = false; // 单选是否点击编辑进入请求完数据操作不在请求
            this.editCheckboxFlag = false; // 单选是否点击编辑进入请求完数据操作不在请求
            this.editJustifyFlag = false; // 单选是否点击编辑进入请求完数据操作不在请求
            this.radioQuestionNumber = 1; // 单选问题序号
            this.checkboxQuestionNumber = 0; // 多选问题序号
            this.justifyQuestionNumber = 0; // 判断题问题序号
            this.updateQuestionNumberList = []; // 更新的题目序号列表
            this.secondCountMin = 1;
            this.getExamDetail(row.metaExamId);
            this.metaQuestionId = null; // 当前问题id
            this.metaQuestionType = 1; // 当前问题类型
            this.metaQuestionIndex = null; // 当前问题下标
            this.addQuestionList = []; // 新增的列表
            this.updateQuestionList = [];// 修改的列表
            this.deleteQuestionIdList = []; // 删除列表
            this.radioQuestionList = []; // 单选的数据列表
            this.checkboxQuestionList = []; // 多选的数据列表
            this.justifyQuestionList = []; // 判断的数据列表
            this.uploadFlag = false; // 是不是导入的标识
            this.initFlage = false; // 是不是导入的标识
            this.activeaddId = null // 当前新增的id
            this.selectedAllChecked = false; // 课程全选标识
            this.questionTableInit();
            this.measureInfoDialog = true;
        },
        getExamDetail(id) {
            partTestDetail(id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.form = {
                        title: data.metaExamName,
                        course: [],
                        time: data.metaExamTime,
                        num: data.metaMaxExamCount
                    };
                    if (this.isAfterStartTime && this.editFlag) {
                        this.secondCountMin = data.metaMaxExamCount
                    }
                    this.courseCheckList = data.courseIdList;
                    this.answerRadio = '';
                    this.questionOptions = [];
                    this.questionAnswer = '';
                    this.getHasSelectedCourse();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        async viewQuestionDetail(row, index, initTab = true) {
            this.questionOptions = []
            this.questionAnswer = '';
            this.metaQuestionId = row.metaQuestionId
            this.metaQuestionType = row.metaQuestionType || this.metaQuestionType
            this.metaQuestionIndex = index
            this.activeaddId = row.addId || null
            var data = row;
            this.exercise.title = data.metaQuestionTitle || '';
            this.exercise.analysis = data.metaQuestionAnalysis || '';
            var optionArr = data.metaQuestionOptions ? JSON.parse(data.metaQuestionOptions) : [];
            var exerciseModeVal = data.metaQuestionType || this.metaQuestionType;
            var answerVal = data.metaQuestionAnswer || '';
            var exerciseMode = 'radio'
            if (this.metaQuestionType === 1) {
                exerciseMode = 'radio'
            } else if (this.metaQuestionType === 2) {
                exerciseMode = 'checkbox'
            } else if (this.metaQuestionType === 3) {
                exerciseMode = 'justify'
            }
            if ((!optionArr || optionArr.length === 0) && initTab) {
                this.handleMeasureTab(exerciseMode, false);
            }
            if (exerciseModeVal == 2) {
                if (answerVal != '') {
                    var answerArr = answerVal.split('');
                    this.setDefaultAnswer(exerciseModeVal, optionArr, answerArr);
                }
            } else {
                this.answerRadio = answerVal;
                this.setDefaultAnswer(exerciseModeVal, optionArr);
            }
            // 如果存在问题id和没有编辑过请求查询
            if (row.metaQuestionId && !row.editQuestionFlag) {
                await partTestQuestionDetail(row.metaQuestionId, {}, {
                    Authorization: this.token,
                    DeptId: this.dept
                }).then(res => {
                    if (res.code == 200) {
                        var data = res.data;
                        this.exercise.title = data.metaQuestionTitle;
                        this.exercise.analysis = data.metaQuestionAnalysis;
                        var optionArr = JSON.parse(data.metaQuestionOptions);
                        var exerciseModeVal = data.metaQuestionType;
                        var answerVal = data.metaQuestionAnswer;
                        if (exerciseModeVal == 2) {
                            if (answerVal != '') {
                                var answerArr = answerVal.split('');
                                this.setDefaultAnswer(exerciseModeVal, optionArr, answerArr);
                            }
                        } else {
                            this.answerRadio = answerVal;
                            this.setDefaultAnswer(exerciseModeVal, optionArr);
                        }
                    }
                    return;
                }).catch(err => {
                    // console.log(err);
                });
            }
            this.initFlage = true
        },
        setDefaultAnswer(mode, optionArr, answerArr) {
            var newArr = [];
            for (var i = 0; i < optionArr.length; i++) {
                var item = optionArr[i];
                var newOption = {
                    label: item.value,
                    title: '正确',
                    value: item.label,
                    checked: false
                }
                if (mode == 2) {
                    var isHas = answerArr.indexOf(item.value);
                    if (isHas >= 0) {
                        newOption["checked"] = true;
                    }
                }
                newArr.push(newOption);
                if (optionArr.length - 1) {
                    this.exercise.options = newArr;
                    if (mode == 2) {
                        this.changeCheckbox();
                    } else {
                        this.changeOptions();
                    }
                }
            }
        },
        submitEditTest() {
            this.submitAddTest();
        },
        handleDelete(row) {
            this.activeDelete = row;
            this.deletePlanDialog = true;
        },
        cancelDeletePartPlan() {
            this.deletePlanDialog = false;
        },
        deletePartPlan() {
            var activeDelete = this.activeDelete;
            var metaExamId = activeDelete.metaExamId;
            removePartPlan(metaExamId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.deletePlanDialog = false;
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.reqTwoMethodsFlag = true
                    this.getTableData();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        downloadTemplete() {
            axios({
                method: 'get',
                url: `${baseUrl}/api/saas/mplan/planStageExamTemplate`,
                headers: {
                    Authorization: this.token,
                    DeptId: this.dept
                },
                responseType: 'blob',
                data: {}
            }).then((res) => {
                let blob = new Blob([res.data], {
                    type: 'data:application/vnd.ms-excel;base64;charset=utf-8'
                });
                let downloadElement = document.createElement('a');
                let href = window.URL.createObjectURL(blob);
                downloadElement.href = href;
                downloadElement.download = 'templete.xls';
                document.body.appendChild(downloadElement);
                downloadElement.click();
                document.body.removeChild(downloadElement);
                window.URL.revokeObjectURL(href);
                return;
            }).catch((error) => {
                // console.log(error);
            })
        },
        handleUpload() {
            var form = this.form;
            var metaExamName = form.title;
            if (metaExamName == '') {
                this.$message.error('请输入阶段测评标题');
                return false;
            }
            var courseCheckList = this.courseCheckList;

            if (this.skip == false) {
                if (courseCheckList.length == 0) {
                    this.$message.error('请选择相关课程');
                    return;
                }
            }
            // if (courseCheckList.length == 0) {
            //     this.$message.error('请选择相关课程222222222');
            //     return false;
            // }
            var metaExamTime = form.time;
            if (metaExamTime == '') {
                this.$message.error('请输入阶段测试时长');
                return false;
            }
            if (isNaN(metaExamTime)) {
                this.$message.error('阶段测试时长应输入数字');
                return false;
            }
            var metaMaxExamCount = form.num;
            if (metaMaxExamCount == '') {
                this.$message.error('请输入可作答次数');
                return false;
            }
            if (isNaN(metaMaxExamCount)) {
                this.$message.error('可作答次数应输入数字');
                return false;
            }
            this.uploadShowFlag = true
            this.$nextTick(() => {
                document.getElementById('uploadBtn').click();
            })

        },
        uploadTemplete(file, fileList) {
            var form = this.form;
            let formDatas = new FormData();
            formDatas.append('file', file.raw);
            var courseCheckList = this.courseCheckList;
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            var params = {
                metaExamName: form.title,
                metaExamId: this.activExamId || undefined,
                courseIdList: JSON.stringify(courseCheckList),
                metaExamTime: form.time,
                metaMaxExamCount: form.num,
                planId: planInfo.id,
                type: 1,
                userId: 0
            };
            importPlanList(Qs.stringify(params), formDatas, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(async (res) => {
                if (res.code == 200) {
                    // if(!this.hasAddTest){
                    params["metaExamId"] = res.data;
                    this.activExamId = res.data;
                    // }
                    this.uploadShowFlag = false
                    this.uploadActivExamId = res.data;
                    var planData = JSON.parse(window.localStorage.getItem('plan'));
                    planData.addTest.isFinish = true;
                    planData.addTest.content = params;
                    window.localStorage.setItem('plan', JSON.stringify(planData));
                    this.hasAddTest = true;
                    var exerciseMode = this.exerciseMode;
                    this.uploadFlag = true
                    await this.uploadAddData();
                    // this.handleMeasureTab(exerciseMode,true,true);
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.$nextTick(() => {
                        if (this.exerciseTable && this.exerciseTable.length !== 0) {
                            this.viewQuestionDetail(this.exerciseTable[0], 0, false)
                        }
                    })
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        // 上传后处理数据
        async uploadAddData() {
            var questionMode = this.exerciseMode;
            var questionType;
            switch (questionMode) {
                case 'radio': questionType = 1; break;
                case 'checkbox': questionType = 2; break;
                case 'justify': questionType = 3; break;
            }
            await partTestQuestionList(this.uploadActivExamId, questionType, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    // 如果存在问题id请求查询
                    if (res.data && res.data.length !== 0) {
                        switch (this.metaQuestionType) {
                            case 1:
                                if (this.radioQuestionList.length !== 0 && this.radioQuestionList[this.radioQuestionList.length - 1] && !this.radioQuestionList[this.radioQuestionList.length - 1].metaQuestionTitle) {
                                    this.radioQuestionList = [...res.data, ...this.radioQuestionList]
                                } else {
                                    // 处理导入的排序
                                    this.updateQuestionNumberList = res.data.map((item, index) => {
                                        return {
                                            metaQuestionId: item.metaQuestionId,
                                            metaQuestionNumber: this.radioQuestionList.length + (index + 1)
                                        }
                                    })
                                    this.radioQuestionList = [...this.radioQuestionList, ...res.data]
                                }
                                this.setExerciseTable('radio');
                                break;
                            case 2:
                                if (this.checkboxQuestionList.length !== 0 && this.checkboxQuestionList[this.checkboxQuestionList.length - 1] && !this.checkboxQuestionList[this.checkboxQuestionList.length - 1].metaQuestionTitle) {
                                    this.checkboxQuestionList = [...res.data, ...this.checkboxQuestionList]
                                } else {
                                    // 处理导入的排序
                                    this.updateQuestionNumberList = res.data.map((item, index) => {
                                        return {
                                            metaQuestionId: item.metaQuestionId,
                                            metaQuestionNumber: this.checkboxQuestionList.length + (index + 1)
                                        }
                                    })
                                    this.checkboxQuestionList = [...this.checkboxQuestionList, ...res.data]
                                }
                                this.setExerciseTable('checkbox');
                                break;
                            case 3:
                                if (this.justifyQuestionList.length !== 0 && this.justifyQuestionList[this.justifyQuestionList.length - 1] && !this.justifyQuestionList[this.justifyQuestionList.length - 1].metaQuestionTitle) {
                                    this.justifyQuestionList = [...res.data, ...this.justifyQuestionList]
                                } else {
                                    // 处理导入的排序
                                    this.updateQuestionNumberList = res.data.map((item, index) => {
                                        return {
                                            metaQuestionId: item.metaQuestionId,
                                            metaQuestionNumber: this.justifyQuestionList.length + (index + 1)
                                        }
                                    })
                                    this.justifyQuestionList = [...this.justifyQuestionList, ...res.data]
                                }
                                this.setExerciseTable('justify');
                                break;
                            default:
                                break;
                        }
                        // partTestQuestionDetail(res.data[0].metaQuestionId,{},{
                        //     Authorization:this.token,
                        //     DeptId:this.dept
                        // }).then(detailRes => {
                        //     if(detailRes.code==200){
                        //         addId ++
                        //         let addIdVal = addId
                        //         this.addQuestionList.push({...detailRes.data,...{addId: addIdVal}})
                        //         this.exerciseTable.push({...detailRes.data,...{addId: addIdVal}})
                        //         switch (detailRes.data.metaQuestionType) {
                        //             case 1:
                        //                 this.radioQuestionList.push({...detailRes.data,...{addId: addIdVal}})
                        //                 this.setExerciseTable('radio');
                        //                 break;
                        //             case 2:
                        //                 this.checkboxQuestionList.push({...detailRes.data,...{addId: addIdVal}})
                        //                 this.setExerciseTable('checkbox');
                        //                 break;
                        //             case 3:
                        //                 this.justifyQuestionList.push({...detailRes.data,...{addId: addIdVal}})
                        //                 this.setExerciseTable('justify'); 
                        //                 break;

                        //             default:
                        //                 break;
                        //         }
                        //     }
                        //     return;
                        // }).catch(err => {
                        //    // console.log(err);
                        // });
                    }
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleAvatarSuccess() {
            this.$refs.upload.clearFiles();
        },
        getHasSelectedCourse() {
            var planInfo = JSON.parse(window.localStorage.getItem('plan'));
            hasSelectedCourse({
                "deptId": this.dept,
                "keyword": "",
                "pageNum": 1,
                "pageSize": 1000,
                "planId": planInfo.id
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data.list;
                    var newArr = [];
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];
                        item["checked"] = false;
                        newArr.push(item);
                        if (i == data.length - 1) {
                            this.form.course = newArr;
                        }
                    }
                    this.courseCheckChange()
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        async handleMeasureTab(target, assignment = true, clickTab = false) {
            if (assignment) {
                this.activeaddId = null;
                this.metaQuestionId = null;
            }
            this.exerciseMode = target;
            this.exercise.title = '';
            this.exercise.analysis = '';
            switch (target) {
                case 'radio':
                    this.metaQuestionType = 1
                    this.exercise.options = [
                        {
                            label: 'A',
                            title: '正确',
                            value: '',
                            checked: false
                        },
                        {
                            label: 'B',
                            title: '正确',
                            value: '',
                            checked: false
                        },
                        {
                            label: 'C',
                            title: '正确',
                            value: '',
                            checked: false
                        },
                        {
                            label: 'D',
                            title: '正确',
                            value: '',
                            checked: false
                        }
                    ];
                    this.answerRadio = '';
                    break;
                case 'checkbox':
                    this.metaQuestionType = 2
                    this.exercise.options = [
                        {
                            label: 'A',
                            title: '正确',
                            value: '',
                            checked: false
                        },
                        {
                            label: 'B',
                            title: '正确',
                            value: '',
                            checked: false
                        },
                        {
                            label: 'C',
                            title: '正确',
                            value: '',
                            checked: false
                        },
                        {
                            label: 'D',
                            title: '正确',
                            value: '',
                            checked: false
                        }
                    ];
                    break;
                case 'justify':
                    this.metaQuestionType = 3
                    this.exercise.options = [
                        {
                            label: 'A',
                            title: '正确',
                            value: '',
                            checked: false
                        },
                        {
                            label: 'B',
                            title: '错误',
                            value: '',
                            checked: false
                        }
                    ];
                    this.answerRadio = '';
                    break;
            };
            // 编辑
            if (this.activExamId != '' && assignment && ((this.metaQuestionType === 1 && !this.editRadioFlag) || (this.metaQuestionType === 2 && !this.editCheckboxFlag) || (this.metaQuestionType === 3 && !this.editJustifyFlag))) {
                await this.getPlanQuestionList();
            } else if (assignment) { // 新增
                this.setExerciseTable(target)
            }
            if (this.initFlage && clickTab) {
                this.$nextTick(() => {
                    if (this.exerciseTable && this.exerciseTable.length !== 0) {
                        this.viewQuestionDetail(this.exerciseTable[0], 0, false)
                    }
                })
            }

        },
        // 设置题目号数据
        setExerciseTable(target) {
            switch (target) {
                case 'radio':
                    this.exerciseTable = JSON.parse(JSON.stringify(this.radioQuestionList))
                    break;
                case 'checkbox':
                    this.exerciseTable = JSON.parse(JSON.stringify(this.checkboxQuestionList))
                    break;
                case 'justify':
                    this.exerciseTable = JSON.parse(JSON.stringify(this.justifyQuestionList))
                    break;

                default:
                    break;
            }
            if (this.exerciseTable.length === 0 && this.activeModeType === 'add') {
                addId++
                let addIdVal = addId
                this.$set(this.exerciseTable, this.exerciseTable.length, {
                    metaQuestionId: null,
                    addId: addIdVal
                })
                // 判断序号
                let metaQuestionNumber = 1
                if (this.exerciseMode === 'radio') {
                    this.radioQuestionNumber++
                    metaQuestionNumber = this.radioQuestionNumber; // 单选
                } else if (this.exerciseMode === 'checkbox') { // 多选
                    this.checkboxQuestionNumber++
                    metaQuestionNumber = this.checkboxQuestionNumber
                } else if (this.exerciseMode === 'justify') { // 判断题
                    this.justifyQuestionNumber++
                    metaQuestionNumber = this.justifyQuestionNumber
                }
                this.addQuestionList.push({
                    metaQuestionId: null,
                    addId: addIdVal,
                    metaQuestionNumber,
                })
                switch (target) {
                    case 'radio':
                        this.radioQuestionList.push({ metaQuestionId: null, addId: addIdVal, metaQuestionNumber })
                        break;
                    case 'checkbox':
                        this.checkboxQuestionList.push({ metaQuestionId: null, addId: addIdVal, metaQuestionNumber })
                        break;
                    case 'justify':
                        this.justifyQuestionList.push({ metaQuestionId: null, addId: addIdVal, metaQuestionNumber })
                        break;

                    default:
                        break;
                }
            }
        },
        changeOptions() {
            var options = this.exercise.options;
            var newArr = [];
            for (var i = 0; i < options.length; i++) {
                var item = options[i];
                var newOption = {
                    "value": item.label,
                    "label": item.value
                }
                newArr.push(newOption);
                if (options.length - 1) {
                    this.questionOptions = newArr;
                }
            }
            switch (this.exerciseMode) {
                case 'radio':
                    var answerVal = this.answerRadio;
                    if (answerVal != '') {
                        this.questionAnswer = answerVal;
                    }
                    break;
                case 'justify':
                    var answerVal = this.answerRadio;
                    if (answerVal != '') {
                        this.questionAnswer = answerVal;
                    }
                    break;
                case 'checkbox':
                    break;
            }
            this.setaddUpdateQuestionList()
        },
        changeCheckbox() {
            var options = this.exercise.options;
            var answerVal = '';
            var newArr = [];
            for (var i = 0; i < options.length; i++) {
                var item = options[i];
                if (item.checked) {
                    answerVal += item.label;
                }
                var newOption = {
                    "value": item.label,
                    "label": item.value
                }
                newArr.push(newOption);
                if (i == options.length - 1) {
                    if (answerVal != '') {
                        this.questionAnswer = answerVal;
                    }
                    this.questionOptions = newArr;
                }
            }
            this.setaddUpdateQuestionList()
        },
        handleCancelAddMeasure() {
            if (this.hasAddTest) {
                this.cancelDealDialog = true;
            } else {
                this.measureInfoDialog = false;
            }
        },
        handleCancelEditMeasure() {
            this.measureInfoDialog = false;
        },
        handleCancelDeal() {
            this.cancelDealDialog = false;
            this.measureInfoDialog = false;
        },
        cancelDealTips() {
            this.cancelDealDialog = false;
        },
        // 课程列表选择
        courseCheckChange() {
            if (this.form.course && this.form.course.length > 0 && this.courseCheckList.length > 0) {
                if (this.form.course.length === this.courseCheckList.length) {
                    this.selectedAllChecked = true
                }
            } else {
                this.selectedAllChecked = false
            }
        },
        // 全选
        handleTotalSelected() {
            if (this.selectedAllChecked) {
                this.courseCheckList = this.form.course.map((item) => {
                    return item.courseId;
                });
            } else {
                this.courseCheckList = [];
            }
        },
        // 设置颜色
        setmeasureNotAvtive(item) {
            let calssNmae = '';
            if (item.metaQuestionId && item.metaQuestionId !== this.metaQuestionId) {
                calssNmae = 'measure-not-avtive'
            } else if (item.addId && item.addId !== this.activeaddId) {
                calssNmae = 'measure-not-avtive'
            }
            return calssNmae
        }
    }
}
</script>

<style scoped>
.page-container {
    display: flex;
}

.page-wrapper {
    flex: 1;
    margin-top: 40px;
    padding-bottom: 80px;
    border-bottom: solid #F0F0F0 1px;
}

.page-header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-header-title-label {
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

.page-info-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
}

.page-info {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
}

.page-fresh-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #FF9645;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF9645;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-fresh-btn:hover {
    cursor: pointer;
    background: #FF9645;
    color: #fff;
}

.page-content-wrapper {
    margin-top: 35px;
    display: flex;
    flex-wrap: wrap;
}

.page-content-item-wrapper {
    width: 180px;
    height: 207px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid rgba(182, 182, 182, 0.5);
    margin-right: 38px;
}

.info-img-wrapper {
    margin-top: 27px;
    text-align: center;
}

.info-img {
    width: 61px;
    height: 64px;
}

.page-content-item-label-wrapper {
    width: 100%;
    height: 40px;
    background: #E4E4E4;
    margin-top: 27px;
}

.page-content-item-label {
    width: 90%;
    margin: 0 auto;
    height: 40px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    line-height: 40px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}

.page-content-btn-wrapper {
    display: flex;
    justify-content: end;
    margin-top: 15px;
}

.page-content-btn {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-content-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.content-btn-gap {
    margin-left: 10px;
    margin-right: 20px;
}

.page-content-item-add {
    width: 180px;
    height: 207px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid rgba(182, 182, 182, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.page-content-item-add:hover {
    cursor: pointer;
    background: rgba(182, 182, 182, 0.2);
}

.add-img {
    width: 42px;
    height: 41px;
}

.page-bottom-wrapper {
    display: flex;
    justify-content: space-around;
    margin-top: 50px;
    padding-bottom: 50px;
}

.page-bottom-label {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #848F9A;
}

.page-btn-wrapper {
    display: flex;
}

.page-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.deal-btn {
    background: #3E63EE;
    color: #FFFFFF;
}

.deal-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.cancel-btn {
    border: 1px solid #4F79ED;
    color: #4F79ED;
}

.cancel-btn:hover {
    cursor: pointer;
    background: #4F79ED;
    color: #fff
}

.btn-gap {
    margin-left: 20px;
}

.dialog-container>>>.el-dialog__body {
    padding: 0px !important;
}

.dialog-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-content>>>.el-form-item__label {
    text-align: left !important;
    font-size: 16px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #333333 !important;
}

.dialog-content>>>.el-input__inner {
    height: 40px !important;
    background: #FFFFFF !important;
    border-radius: 6px !important;
    border: 1px solid #D9D9D9 !important;
}

.dialog-form-option-radio {
    margin-top: 3px;
    height: 30px;
    line-height: 30px;
}

.dialog-header {
    width: 100%;
    height: 52px;
    background: rgb(244, 244, 244);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.dialog-content {
    padding: 16px 40px 0px 40px;
    display: flex;
}

.dialog-content-item1 {
    width: 500px;


}

.dialog-content-item2 {
    width: 500px;


}

.dialog-form-label {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-top: 15px;
    display: flex;
}

.dialog-label-block {
    width: 140px;
    display: flex;
}

.dialog-form-content {
    width: 100%;
    margin-top: 12px;
}

.dialog-form-require {
    color: #EB6C48;
    font-size: 12px;
    margin-left: 2px;
}

.dialog-form-checkbox-container {
    height: 219px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
}

.dialog-form-checkbox-wrapper {
    flex: 1;
    margin-top: 5px;
    margin-bottom: 5px;
}

.dialog-form-checkbox {
    flex: 1;
    margin-left: 16px;
    /* display: flex; */
    margin-bottom: 5px;
    margin-top: 5px;
}

.dialog-form-all-check {
    margin-left: 16px;
}

.dialog-form-checkbox>>>.el-checkbox {
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #606A74 !important;
}

.dialog-form-checkbox>>>.el-radio {
    font-size: 18px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    color: #606A74 !important;
}

.selected-header-count>>>.el-input__inner {
    width: 110px !important;
    height: 28px !important;
    border-radius: 14px !important;
    border: 1px solid #3E63EE !important;
    color: #3E63EE !important;
}

.selected-header-count>>>.el-input-number--mini {
    width: 110px !important;
    height: 28px !important;
}

.selected-header-count>>>.el-input-number__decrease {
    background: #fff !important;
    border-top-left-radius: 24px !important;
    border-bottom-left-radius: 24px !important;
    color: #3E63EE !important;
}

.selected-header-count>>>.el-input-number__increase {
    background: #fff !important;
    border-top-right-radius: 24px !important;
    border-bottom-right-radius: 24px !important;
    color: #3E63EE !important;
}

.dialog-count-unit {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #606A74;
    display: flex;
    align-items: center;
    margin-left: 7px;
}

.dialog-form-brief {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 27px;
    margin-top: 77px;
}

.dialog-form-line {
    width: 1px;
    height: 594px;
    background: #F0F0F0;
    margin: 16px 52px 0px 52px;
}

.add-measure-header-wrapper {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.add-measure-task-mode {
    display: flex;
}

.add-measure-header-operate {
    display: flex;
}

.add-measure-btn {
    height: 40px;
    border: 1px solid #3E63EE;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.measure-templete-btn {
    width: 98px;
    border-radius: 6px;
    color: #4F79ED;
}

.measure-templete-btn:hover {
    cursor: pointer;
    background: #4F79ED;
    color: #fff;
}

.measure-upload-btn {
    width: 98px;
    background: #3E63EE;
    border-radius: 6px;
    color: #fff;
    margin-left: 15px;
}

.not-upload {
    pointer-events: none;
    color: #c0c4cc;
    border-color: #c0c4cc;
}

.measure-upload-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.add-measure-mode-btn {
    width: 80px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #3E63EE;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
}

.add-measure-radio-btn {
    border: 1px solid #3E63EE;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
}

.add-measure-justify-btn {
    border: 1px solid #3E63EE;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
}

.add-measure-checkbox-btn {
    border: 1px solid #3E63EE;
    border-left: 0;
    border-right: 0;
}

.add-measure-mode-btn-active {
    width: 80px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    background: #3E63EE;
    color: #fff;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
}

.add-measure-exercise-container {
    height: 174px;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    margin-top: 24px;
    display: flex;
    overflow-x: hidden;
    overflow-y: auto;
}

.add-measure-exercise-wrapper {
    flex: 1;
    margin: 20px;
}

.add-measure-exercis-item {
    float: left;
    width: 36px;
    height: 36px;
    background: #3E63EE;
    border-radius: 6px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 14.5px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.add-measure-exercis-item:hover {
    cursor: pointer;
    opacity: 0.8;
}

.measure-not-avtive {
    background: #fff;
    border: 1px solid #3E63EE;
    color: #3E63EE;
}

.dialog-form-textarea {
    width: 400px;
    margin-left: 10px;
}

.dialog-form-option-wrapper {
    display: flex;
    margin-bottom: 7px;
}

.dialog-form-option-input {
    flex: 1;
    display: flex;
    margin-left: 9px;
}

.dialog-form-option-input>>>.el-input__inner {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.add-measure-bottom-btn-wrapper {
    display: flex;
    justify-content: end;
    margin-top: 30px;
}

.add-measure-bottom-btn {
    width: 80px;
    height: 36px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.add-measure-delete-btn {
    color: #4F79ED;
    border: 1px solid #4F79ED;
}

.add-measure-delete-btn:hover {
    color: #fff;
    background: #4F79ED;
    cursor: pointer;
}

.add-measure-keep-add-btn {
    background: #3E63EE;
    color: #fff;
    margin-left: 16px;
}

.add-measure-keep-add-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.dialog-footer {
    height: 108px;
    background: rgb(244, 244, 244);
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: end;
}

.dialog-footer-btn {
    width: 108px;
    height: 44px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
}

.dialog-footer-cancel {
    color: #4F79ED;
    border: 1px solid #4F79ED;
}

.dialog-footer-deal {
    background: #3E63EE;
    color: #fff;
    margin-right: 40px;
    margin-left: 20px;
}

.dialog-footer-cancel:hover {
    background: #4F79ED;
    color: #fff;
    cursor: pointer;
}

.dialog-footer-deal:hover {
    cursor: pointer;
    opacity: 0.8;
}

.dialog-btn-wrapper {
    padding: 0px 40px 40px 40px;
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}
</style>


